import {
  LOADER_STATUS,
  PROFILE_DATA,
  SET_ENTITY_LIST,
  DEFAULT_ENTITY,
  STORE_GSTIN_IMS_RECO,
  STORE_PERIOD_SINGLE,
  STORE_PERIOD,
} from "./constants";

// The initial state of the App
export const initialState = {
  data: [],
  loaderStatus: false,
  profileData: [],
  entityMasterList: [],
  defaultEntity: "",
  selectedGstin: [],
  selectedPeriodSingle: null,
  startDate: null,
  endDate: null,
};

/* eslint-disable default-case, no-param-reassign */
const imsRecoCommonReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };

    case PROFILE_DATA:
      return {
        ...state,
        profileData: action.profileData,
      };

    case SET_ENTITY_LIST:
      return {
        ...state,
        entityMasterList: action.payload,
      };
    case DEFAULT_ENTITY:
      return {
        ...state,
        defaultEntity: action.data,
      };
    case STORE_GSTIN_IMS_RECO:
      return {
        ...state,
        selectedGstin: action.selectedGstin,
      };
    case STORE_PERIOD_SINGLE:
      return {
        ...state,
        selectedPeriodSingle: action.date,
      };
    case STORE_PERIOD:
      return {
        ...state,
        startDate: action.date.startDate,
        endDate: action.date.endDate,
      };
    default:
      return state;
  }
};

export default imsRecoCommonReducer;
